import { produce } from 'immer'
import { accountHistoryRouteProps } from 'src/navigation/routeProps'
import {
  GET_BUDGET_REVISIONS_FAILURE,
  GET_BUDGET_REVISIONS_INIT,
  GET_BUDGET_REVISIONS_SUCCESS,
  GetBudgetRevisionsActions,
  GetBudgetRevisionsPagination,
} from 'src/redux/actions/data/budgetRevisions.actions'
import { createBackgroundReducer } from 'src/redux/genericReducers'

export interface AccountHistoryState {
  revisionsLoading: boolean
  revisionsPagination: GetBudgetRevisionsPagination
  revisionIds: string[]
  fullyLoadedRevisions: boolean
}

export const initialState: AccountHistoryState = {
  revisionsLoading: false,
  revisionsPagination: {},
  revisionIds: [],
  fullyLoadedRevisions: false,
}

export type Actions = GetBudgetRevisionsActions

const BaseAccountHistoryReducer = (
  state = initialState,
  action: Actions,
): AccountHistoryState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_BUDGET_REVISIONS_INIT: {
        draft.revisionsLoading = true
        return draft
      }

      case GET_BUDGET_REVISIONS_FAILURE: {
        draft.revisionsLoading = false
        return draft
      }

      case GET_BUDGET_REVISIONS_SUCCESS: {
        draft.revisionsLoading = false
        if (action.payload.queryParams?.previousCursor !== undefined) {
          draft.revisionIds = [
            ...action.payload.revisions.map((rev) => rev.id),
            ...draft.revisionIds,
          ]
          draft.revisionsPagination = {
            nextCursor:
              draft.revisionsPagination.nextCursor ||
              action.payload.pagination.nextCursor,
            previousCursor:
              action.payload.pagination.previousCursor ||
              draft.revisionsPagination.previousCursor,
          }
        } else {
          const payloadIds = action.payload.revisions.map((rev) => rev.id)
          draft.revisionIds = [...draft.revisionIds, ...payloadIds]
          draft.revisionsPagination = {
            nextCursor:
              action.payload.pagination.nextCursor ||
              draft.revisionsPagination.nextCursor,
            previousCursor:
              draft.revisionsPagination.previousCursor ||
              action.payload.pagination.previousCursor,
          }
          draft.fullyLoadedRevisions =
            action.payload.pagination.nextCursor === undefined
        }
        return draft
      }
    }
  })
}

const CoreAccountHistoryReducer = (
  state = initialState,
  action: Actions,
): AccountHistoryState => BaseAccountHistoryReducer(state, action as Actions)

const AccountHistoryReducer = createBackgroundReducer(
  accountHistoryRouteProps,
  initialState,
  CoreAccountHistoryReducer,
)

export default AccountHistoryReducer
